import { makeStyles } from "@material-ui/core/styles";
const height = "32px";
const optionFocus = {
  backgroundColor: "var(--color-pale-teal)",
  borderColor: "transparent",
};
const selectFont = {
  font: "var(--size-12px) / var(--size-16px) var(--font-family-noto-sans)",
};
export const selectStyles = makeStyles(() => ({
  select: {
    position: "relative",
  },
  input: {
    ...selectFont,
    width: "-webkit-fill-available",
    backgroundColor: "var(--color-white)",
    border: "0.5px solid var(--color-medium-grey)",
    borderRadius: "2px",
    height: height,
    fontSize: 16,
    color: "var(--color-primary-black)",
    boxSizing: "content-box",
    "&:hover": {
      backgroundColor: "var(--color-pale-grey)",
    },
    "&:focus-within": {
      backgroundColor: "var(--color-white)",
      border: "0.5px solid var(--color-light-teal)",
      boxshadow: " inset 0 0 0 1px var(--color-primary-black)",
    },
    "&.Mui-disabled": {
      border: "0.5px solid var(--color-medium-grey)",
      background: "var(--color-light-grey) 0% 0% no-repeat padding-box",
    },
    "& .Mui-error": {
      border: "0.5px solid var(--color-red)",
      boxShadow: "0px 0px 8px var(--color-shadow-red)",
    },
    " & .MuiSelect-select:focus": {
      backgroundColor: "var(--color-white)",
    },
  },
  option: {
    ...selectFont,
    color: "var(--color-medium-grey)",
    paddingLeft: "10px",
    "&:hover": optionFocus,
    '&[aria-selected="true"]': optionFocus,
  },
  placeholder: {
    opacity: "0.7",
    fontSize: "16px",
    color: "var(--color-medium-grey)",
  },
  expandIcon: {
    top: 0,
  },
}));

export const selectMenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  PaperProps: {
    style: {
      maxHeight: 150,
      minWidth: 600,
      marginLeft: -10,
      marginTop: 3,
    },
  },
  getContentAnchorEl: null,
};
